'use strict';

const dynamicColStart = (start)=>{
    switch(start){
        case 1:
            return 'col-start-1';
        case 2:
            return 'col-start-2';
        case 3:
            return 'col-start-3';
        case 4:
            return 'col-start-4';
        case 5:
            return 'col-start-5';
        case 6:
            return 'col-start-6';
        case 7:
            return 'col-start-7';
        case 8:
            return 'col-start-8';
        case 9:
            return 'col-start-9';
        case 10:
            return 'col-start-10';
        case 11:
            return 'col-start-11';
        case 12:
            return 'col-start-12';
        case undefined:
        default:
            return 'col-start-auto';
    }
};

exports.dynamicColStart = dynamicColStart;
//# sourceMappingURL=col-start.js.map
